import { PropsType } from './types';
import { IconStyle } from './styles';

export const Icon = (props: PropsType) => {
  const { img, customWidth, customHeight } = props;

  return <IconStyle customWidth={customWidth} customHeight={customHeight} src={img} alt="icon" />;
};
